import { Customer } from "../interfaces/user.interface";
import axiosInstance from "../utils/axiosInstance";
import dayjs from 'dayjs';

class CustomerApi {

  login(formValues){
    const apiUrl = "/web/customers/sign_in.json";
    return axiosInstance.post(apiUrl, {customer: formValues})
      .then(response => {
        return Promise.resolve(response.data.name);
      })
      .catch(err => Promise.reject(err))
  }


  logout(){
    const apiUrl = "/web/customers/sign_out";
    return axiosInstance.get(apiUrl)
      .then(response => {
        const ok = response.status == 200;
        return Promise.resolve(ok);
      })
      .catch(err => Promise.reject(err))
  }

  forgotPassword(email: string){
    const apiUrl = "/web/customers/password.json";    
    return axiosInstance.post(apiUrl, {customer: {email}})
      .then(response => {
        const ok = response.status == 201;
        return Promise.resolve(ok);
      });
  }

  resetPassword(passwordParams){
    const apiUrl = "/web/customers/password.json";
    return axiosInstance.put(apiUrl, {customer: passwordParams})
      .then(response => Promise.resolve(response))
      .catch(err => Promise.reject(err))
  }

  getProfile(): Promise<Customer>{
    const apiUrl = "/b2c2b/api/v1/customer.json";
    return axiosInstance.get(apiUrl)
      .then(response => {
        const customer = response.data.data.attributes;
        customer.passport_expiry_date = this.convertDateStrToDayJs(customer.passport_expiry_date);
        customer.date_of_birth = this.convertDateStrToDayJs(customer.date_of_birth);
        return Promise.resolve(customer)
      })
      .catch(err => Promise.reject(err))
  }

  updateProfile(userPayload): Promise<Customer>{
    const apiUrl = "/b2c2b/api/v1/customer.json";
    return axiosInstance.put(apiUrl, {customer: userPayload})
      .then(response => {
        const customer: Customer = response.data.data.attributes;
        return Promise.resolve(customer)
      })
      .catch(err => Promise.reject(err))
  }

  updatePassword(passwordParams){
    const apiUrl = "/b2c2b/api/v1/customer/update_password";
    return axiosInstance.put(apiUrl, {customer: passwordParams})
      .then(response => Promise.resolve(response.data))
      .catch(err => Promise.reject(err))
  }


  private convertDateStrToDayJs(dateStr: string){
    return dateStr != null ? dayjs(dateStr) : null;
  }


  //magic links
  requestLink(email){
    const apiUrl = "/customers/magic_auth";
    return axiosInstance.post(apiUrl, {customer: email})
      .then(response => {
        const ok = response.status == 200;
        return Promise.resolve(ok);
      })
      .catch(err => Promise.reject(err))
  }


  setupPassword(passwordPayload){
    const apiUrl = "/customers/password/setup.json";
    return axiosInstance.post(apiUrl, {customer: passwordPayload})
      .then(response => {
        return Promise.resolve(response.data);
      })
      .catch(err => Promise.reject(err))
  }

}

export default new CustomerApi();